import React, {useState, useEffect, useContext} from 'react';
import moment from 'moment';
import {Link} from 'react-router-dom';
import AuditContext from '../Utils/context.js';
import {useLocalStorage} from 'react-use';
import {Button, Col, Row, Card, Form,Container  } from 'react-bootstrap';
import axios from 'axios';
import {
  CustomPaging,
  PagingState,
  SortingState,
  IntegratedSorting,
} from '@devexpress/dx-react-grid';
import {
  Grid,
  PagingPanel,
  Table,
  TableHeaderRow,
  TableColumnResizing,
} from '@devexpress/dx-react-grid-bootstrap4';
import { Loading } from 'components/Loading/loading';
import { useAlert, TYPES } from 'hooks/use-alert-hook.js';
import ExcelJS from 'exceljs';

export default function Finding() {

  const {schedule} = useContext(AuditContext);
  const [auth] = useLocalStorage('authenticated');
  const [swal, setSwal] = useAlert(null);
  const [loading, setLoading] = useState(false);
  const [countOpen, setCountOpen] = useState(0);
  const [countComplete, setCountComplete] = useState(0);
  const [countProgress, setCountProgress] = useState(0);
  const [statusAction, setStatusAction] = useState('');
  const [picAction, setPicAction] = useState('');
  const [currentPage, setCurrentPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [listPic, setListPic] = useState([]);
  const [pageSize, setPageSize] = useState(5);
  const [pageSizes] = useState([5, 10, 15]);
  const [sorting, setSorting] = useState([{ columnName: 'ANSWER_ACTION_ID', direction: 'asc' }]);
  const [columns] = useState([
    {name: 'ACTIONS', title: 'Action', getCellValue: row => {

      let variant = `primary`, label = `Open`;
      // switch (row.ANSWER_ACTION_STATUS & row.REJECT_EXPLAIN) {
      //   case 'OPEN' & null:
      //     variant = `danger`;
      //     label = 'OPEN' ;
      //     break;
      //   case 'COMPLETED':
      //     variant = `success`;
      //     label = row?.COMPLETED_AT ? moment(row.COMPLETED_AT, 'DD-MMM-YYYY').format('DD MMM YYYY') : `` ;
      //     break;
      //   case `IN PROGRESS`:
      //     variant = `warning`;
      //     label =  'In Progress';
      // }
      if (row.ANSWER_ACTION_STATUS == 'OPEN') {
        if (row.REJECT_EXPLAIN == null){
          variant = `primary`;
          label = 'Open' ;
        }else{
          variant = `danger`;
          label = 'Open' ;
        }
      }else if (row.ANSWER_ACTION_STATUS == 'COMPLETED'){
        variant = `success`;
        label = row?.COMPLETED_AT ? moment(row.COMPLETED_AT, 'DD-MMM-YYYY').format('DD MMM YYYY') : `` ;
      }else if (row.ANSWER_ACTION_STATUS == 'IN PROGRESS'){
        variant = `warning`;
        label =  'In Progress';
      }

      return (
        <Link to={`/admin/actions/${row.ANSWER_ACTION_ID}/edit`}>
          <Button variant={variant} size="sm">{label}</Button>
        </Link>
      );
    }},
    {name: 'ANSWER_ACTION_ID', title: 'ID', getCellValue: row => row.ANSWER_ACTION_ID},
    {name: 'CRITERIA', title: 'Criteria', getCellValue: row => row?.answer?.form?.criteria.CRITERIA_LABEL ?? `n-a`},
    {name: 'EVALUATE_DESC', title: 'Evaluation', getCellValue: row => row?.answer.EVALUATE_DESC ?? `n-a`},
    {name: 'CAUSE_DESC', title: 'Finding', getCellValue: row => row?.answer.CAUSE_DESC ?? `n-a`},
    {name: 'TYPE', title: 'Type', getCellValue: row => row?.actionType.ACTION_TYPE_NAME ?? `n-a`},
    {name: 'DUE_DATE', title: 'Due Date', getCellValue: row => row?.DUE_DATE ? moment(row.DUE_DATE, 'DD-MMM-YYYY').format('DD MMM YYYY') : ``},
    {name: 'PIC', title: `PIC`, getCellValue: row => row?.pics?.map(pic => pic?.employee?.EMP_NAME).join(`, `)},

  ]);

  const [defaultColumnWidths] = useState([
    {columnName: 'ACTIONS', width: 100 },
    { columnName: 'ANSWER_ACTION_ID', width: 60 },
    { columnName: 'CRITERIA', width: 200 },
    {columnName: 'EVALUATE_DESC', width: 180 },
    {columnName: 'CAUSE_DESC', width: 180 },
    {columnName: 'TYPE', width: 180 },
    {columnName: 'DUE_DATE', width: 180 },
    {columnName: 'PIC', width: 180 },
    {columnName: 'STATUS', width: 180 },
  ]);
  const [columnWidths, setColumnWidths] = useState(defaultColumnWidths);


  const [rows, setRows] = useState([]);

  const getRowId = row => row.ANSWER_ACTION_ID;

  const fetchAnswerActions = async () => {

    setLoading(true);
    try {

      const response = await axios.get(`${process.env.REACT_APP_API_HOST}answer-actions`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
        params: {
          SCHEDULE_ID: schedule.SCHEDULE_ID,
          expand: `answer.form.criteria,pics.employee,actionType`,
          page: currentPage + 1,
          'per-page': pageSize,
        }
      });

      setRows(response.data.items);
      setTotalCount(response.data._meta.totalCount);

    } catch (error) {
      console.log(error);
      alert(`error`);
    }

    setLoading(false);
  };

  const fetchCountingAnswerActions = async () => {

    try {

      const response = await axios.get(`${process.env.REACT_APP_API_HOST}answer-action/count-status`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
        params: {
          id: schedule.SCHEDULE_ID
        }
      });
      response.data.result.forEach(data => {
        if(data.ANSWER_ACTION_STATUS=='OPEN'){
          setCountOpen(data.JUMLAH)
        }else if(data.ANSWER_ACTION_STATUS=='IN PROGRESS'){
          setCountProgress(data.JUMLAH)
        }else if(data.ANSWER_ACTION_STATUS=='COMPLETED'){
          setCountComplete(data.JUMLAH)
        }
      })

    } catch (error) {
      console.log(error);
      alert(`error`);
    }
  };

  const fetchSearchAnswerActions = async () => {

    setLoading(true);

    try {

      const response = await axios.get(`${process.env.REACT_APP_API_HOST}answer-actions`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
        params: {
          SCHEDULE_ID: schedule.SCHEDULE_ID,
          expand: `answer.form.criteria,pics.employee,actionType`,
          ANSWER_ACTION_STATUS: statusAction,
          picstest: picAction
        }
      });

      setRows(response.data.items);
      setTotalCount(response.data._meta.totalCount);

    } catch (error) {
      console.log(error);
      alert(`error`);
    }

    setLoading(false);
  };

  const handleSendReminder = async () => {
    try {

      const onSuccessCallback = async () => {
        let formData = new FormData();
        formData.append('TYPE', 'REMINDER_FINDING');
        formData.append('EMAIL', JSON.parse(localStorage.getItem('authenticated')).employee.EMP_EMAIL);
        formData.append('SCHEDULE', schedule.SCHEDULE_ID);
        const response = await axios.post(`${process.env.REACT_APP_API_HOST}notification/send-email`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${JSON.parse(localStorage.getItem('authenticated')).token}`,
          }
        });
      }


      setSwal({
        type: TYPES.CONFIRM,
        payload: {
          title: `Confirmation!`,
          message: `Are you sure want to send notificaiton reminder finding?`,
          onSuccess: {
            title: `Success`,
            message: `Notification Reminder Finding has been Send`,
            callback: onSuccessCallback,
          }
        }
      });

    } catch (error) {
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }
  }

  const handleSendReject = async () => {
    try {

        const onSuccessCallback = async () => {
          let formData = new FormData();
          formData.append('TYPE', 'REJECT_FINDING');
          formData.append('EMAIL', JSON.parse(localStorage.getItem('authenticated')).employee.EMP_EMAIL);
          formData.append('SCHEDULE', schedule.SCHEDULE_ID);
          const response = await axios.post(`${process.env.REACT_APP_API_HOST}notification/send-email`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${JSON.parse(localStorage.getItem('authenticated')).token}`,
            }
          });
        }

        setSwal({
          type: TYPES.CONFIRM,
          payload: {
            title: `Confirmation!`,
            message: `Are you sure want to send notificaiton reject?`,
            onSuccess: {
              title: `Success`,
              message: `Notification Reject has been Send`,
              callback: onSuccessCallback,
            }
          }
        });

    } catch (error) {
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }
  }

  const fetchListPIC = async () => {

    try {

      const response = await axios.get(`${process.env.REACT_APP_API_HOST}answer-action/list-pic`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
        params: {
          id: schedule.SCHEDULE_ID
        }
      });
      if(response.data.result.length>0){
        setListPic(response.data.result)
      }else{
        setListPic([])
      }

    } catch (error) {
      console.log(error);
      alert(`error`);
    }
  };



  const handleExportToExcel = async () => {
    setLoading(true);

    try {
      const response = await axios.get(`${process.env.REACT_APP_API_HOST}answer-action/finding-export-excel`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
        params: {
          id: schedule.SCHEDULE_ID
        }
      });

      const dataResult = response.data.result;

      // 1. Create Workbook and Worksheet
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Audit Findings');

      // 2. Define Columns (Mapping keys to your SQL query results)
      worksheet.columns = [
        { header: 'No', key: 'no', width: 5 },
        { header: 'Answer Action Id', key: 'ANSWER_ACTION_ID', width: 10 },
        { header: 'Criteria', key: 'CRITERIA_LABEL', width: 25 },
        { header: 'Evaluation', key: 'EVALUATE_DESC', width: 50 },
        { header: 'Finding', key: 'CAUSE_DESC', width: 50 },
        { header: 'Action Plan', key: 'PLAN_DESC', width: 50 },
        { header: 'Type', key: 'ACTION_TYPE_NAME', width: 20 },
        { header: 'Due Date', key: 'DUE_DATE', width: 20 },
        { header: 'PIC Names', key: 'PIC_NAMES', width: 50 },
        { header: 'Status', key: 'ANSWER_ACTION_STATUS', width: 10 },
        { header: 'Reject Explain', key: 'REJECT_EXPLAIN', width: 50 },
      ];

      // 3. Add Rows from your API Result
      dataResult.forEach((item, index) => {
        worksheet.addRow({
          no: index + 1,
          ANSWER_ACTION_ID: item.ANSWER_ACTION_ID,
          CRITERIA_LABEL: item.CRITERIA_LABEL,
          EVALUATE_DESC: item.EVALUATE_DESC,
          CAUSE_DESC: item.CAUSE_DESC,
          PLAN_DESC: item.PLAN_DESC,
          ACTION_TYPE_NAME: item.ACTION_TYPE_NAME,
          DUE_DATE: item.DUE_DATE,
          PIC_NAMES: item.PIC_NAMES,
          ANSWER_ACTION_STATUS: item.ANSWER_ACTION_STATUS,
          REJECT_EXPLAIN: item.REJECT_EXPLAIN
        });
      });

      // 4. Make the Header Row look nice (Bold, Blue Background, White Text)
      worksheet.getRow(1).eachCell((cell) => {
        cell.font = { bold: true, color: { argb: 'FFFFFF' } };
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '4F81BD' }
        };
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
      });

      // 5. Generate Buffer and Trigger Download (Vanilla JS way)
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);

      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = `Finding_Report_${schedule.SCHEDULE_ID}.xlsx`;
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.log(error);
      alert(`Error exporting excel`);
    }

    setLoading(false);
  };

  useEffect(fetchAnswerActions, [pageSize, currentPage]);

  useEffect(fetchCountingAnswerActions, []);

  useEffect(fetchListPIC, []);


  return (
    <>
      {swal}
      <Row style={{width:"100%"}}>
        <Col md="12">
          <h4 style={{marginTop:1, fontWeight:'bold'}} >Finding List</h4>
          <div className="p-3 bg-light rounded shadow-sm border mb-4">
            <Row className="align-items-end">
              <Col xs={12} sm={6} md={3} className="mb-3">
                <Form.Group className="mb-0">
                  <Form.Label className="font-weight-bold small text-uppercase text-muted">
                    Filter Status
                  </Form.Label>
                  <Form.Control
                    as="select"
                    className="custom-select"
                    onChange={e => setStatusAction(e.target.value)}
                  >
                    <option value="">Select Status...</option>
                    <option value='OPEN'>OPEN</option>
                    <option value='IN PROGRESS'>IN PROGRESS</option>
                    <option value='COMPLETED'>COMPLETED</option>
                    <option value=''>All</option>
                  </Form.Control>
                </Form.Group>
              </Col>

              <Col xs={12} sm={6} md={4} className="mb-3">
                <Form.Group className="mb-0">
                  <Form.Label className="font-weight-bold small text-uppercase text-muted">
                    Filter PIC
                  </Form.Label>
                  <Form.Control
                    as="select"
                    className="custom-select"
                    onChange={e => setPicAction(e.target.value)}
                  >
                    <option value="">Select PIC...</option>
                    {listPic.map(dataPIC => (
                      <option key={dataPIC.EMP_ID} value={dataPIC.EMP_ID}>
                        {dataPIC.FORMATTED_NAME}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>

              <Col xs={12} md={2} className="mb-3">
                <Button variant='primary' block onClick={fetchSearchAnswerActions} style={{ height: 'calc(1.5em + .75rem + 2px)' }}>
                  Show
                </Button>
              </Col>
            </Row>

            <Row className="mb-4">
              <Col xs={12} sm={6} md={3} className="mb-2">
                <Button variant='success' block size="sm" onClick={handleSendReminder}>
                  🔔 Notif Finding Reminder
                </Button>
              </Col>
              <Col xs={12} sm={6} md={3} className="mb-2">
                <Button variant='danger' block size="sm" onClick={handleSendReject}>
                  🔔 Notif Finding Reject
                </Button>
              </Col>
              <Col xs={12} sm={6} md={3} className="mb-2">
                <Button variant='outline-info' block size="sm" onClick={handleExportToExcel}>
                  📊 Export Excel
                </Button>
              </Col>
            </Row>

            <Row className="text-center">
              <Col xs={4}>
                <div className="p-2 border rounded bg-white">
                  <small className="text-muted d-block text-uppercase">Open</small>
                  <span className="h5 font-weight-bold text-primary">{countOpen}</span>
                </div>
              </Col>
              <Col xs={4}>
                <div className="p-2 border rounded bg-white">
                  <small className="text-muted d-block text-uppercase">In Progress</small>
                  <span className="h5 font-weight-bold text-warning">{countProgress}</span>
                </div>
              </Col>
              <Col xs={4}>
                <div className="p-2 border rounded bg-white">
                  <small className="text-muted d-block text-uppercase">Completed</small>
                  <span className="h5 font-weight-bold text-success">{countComplete}</span>
                </div>
              </Col>
            </Row>
          </div>
          <Grid
            rows={rows}
            columns={columns}
            getRowId={getRowId}
          >
            <PagingState
              currentPage={currentPage}
              onCurrentPageChange={setCurrentPage}
              pageSize={pageSize}
              onPageSizeChange={setPageSize}
            />
            <SortingState
              sorting={sorting}
              onSortingChange={setSorting}
            />
            <IntegratedSorting />
            <CustomPaging totalCount={totalCount} />
            <Table />
            <TableColumnResizing
              columnWidths={columnWidths}
              onColumnWidthsChange={setColumnWidths}
            />
            <TableHeaderRow showSortingControls />
            <PagingPanel
              pageSizes={pageSizes}
            />
            {loading && <Loading />}
          </Grid>
          {/* <Card>
            <Card.Header>
              <Card.Title as="h4">Finding List</Card.Title>
            </Card.Header>
            <Card.Body>
              <Row>
                <Col sm={6} md={3}>Filter Status : </Col>
                <Col sm={6} md={4}>
                 <Form.Group as={Col}>
                    <Form.Control className="w-100" name="STATUS" as="select" onChange={e => {setStatusAction(e.target.value);}}>
                      <option>Select Status...</option>
                      <option value='OPEN'>OPEN</option>
                      <option value='IN PROGRESS'>IN PROGRESS</option>
                      <option value='COMPLETED'>COMPLETED</option>
                      <option value=''>All</option>
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col sm={6} md={3}><Button variant='primary' size="sm" onClick={fetchSearchAnswerActions}>Show</Button></Col>
                <Col sm={6} md={4}><Button variant='success' size="sm" onClick={handleSendReminder}>Notif Finding Reminder</Button></Col>
                <Col sm={6} md={4}><Button variant='danger' size="sm" onClick={handleSendReject}>Notif Finding Reject</Button></Col>
                <Col sm={6} md={4}></Col>
                <Col sm={6} md={4}>OPEN: {countOpen}</Col>
                <Col sm={6} md={4}>IN PROGRESS: {countProgress}</Col>
                <Col sm={6} md={4}>COMPLETED: {countComplete}</Col>
              </Row>
              <Grid
                rows={rows}
                columns={columns}
                getRowId={getRowId}
              >
                <PagingState
                  currentPage={currentPage}
                  onCurrentPageChange={setCurrentPage}
                  pageSize={pageSize}
                  onPageSizeChange={setPageSize}
                />
                <SortingState
                  sorting={sorting}
                  onSortingChange={setSorting}
                />
                <IntegratedSorting />
                <CustomPaging totalCount={totalCount} />
                <Table />
                <TableColumnResizing
                  columnWidths={columnWidths}
                  onColumnWidthsChange={setColumnWidths}
                />
                <TableHeaderRow showSortingControls />
                <PagingPanel
                  pageSizes={pageSizes}
                />
                {loading && <Loading />}
              </Grid>
            </Card.Body>
          </Card> */}
        </Col>
      </Row>
    </>
  );
}